import React from 'react';

import { DomainObject } from 'types';
import { ApiRoute, GridBodyType, PageKey, SortOrder, UrlRoute } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';
import { actionButtonsFactory } from 'components/grid/right-panel/action-buttons-factory';

import { ArchivalUnitDetail } from './archival-unit-detail';
import { ArchivalUnitAddToCart } from './action-buttons/add-to-cart';
import { GridRightPanelCart } from './action-buttons/cart-info';
import { ArchivalUnitFavourite } from './archival-unit-favourite';
import { ArchivalUnitQuote } from './archival-unit-quote';
import { ArchivalUnitDownload } from './archival-unit-download';
import { findValidDescribingAid } from 'components/grid/v2/context/hierarchy-context';

export const archivalUnitConfig: GridEntityConfig<
  DomainObject,
  DomainObject
> = {
  id: 'archivalie',
  title: 'Archiválie',
  getParent: (item) =>
    findValidDescribingAid(
      item?.archivalUnitReference?.describingArchivalAids
    )!,
  getLabel: (item) => item.numericId?.toString(),
  getId: (item) => item.id,
  urlRoute: UrlRoute.ARCHIVAL_UNIT,
  apiRoute: ApiRoute.ARCHIVAL_UNIT,
  listApi: '/api/archival-unit/public/list',
  pageKey: PageKey.DETAIL_ARCHIVAL_UNIT,
  ActionButtons: actionButtonsFactory([
    { id: 'favourite', Component: ArchivalUnitFavourite },
    { id: 'download', Component: ArchivalUnitDownload },
    { id: 'add-to-cart', Component: ArchivalUnitAddToCart },
    { id: 'grid-cart', Component: GridRightPanelCart },
    { id: 'quote', Component: ArchivalUnitQuote },
  ]),
  icon: 'description',
  bodyComponents: { [GridBodyType.DETAIL]: ArchivalUnitDetail },
  params: {
    sort: [{ field: 'numericId', order: SortOrder.ASC }],
  },
};

export const archivalUnitGridConfig: any[] = [archivalUnitConfig];

export const ArchivalUnitGrid = () => (
  <Grid gridConfig={archivalUnitGridConfig} />
);
